module.exports = __webpack_public_path__ + "static/media/gulp.5d142fd5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/gulp.png
 ** module id = 224
 ** module chunks = 0
 **/